import { render, staticRenderFns } from "./FittingSaleView.vue?vue&type=template&id=8fd3f4de&"
import script from "./FittingSaleView.vue?vue&type=script&lang=js&"
export * from "./FittingSaleView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports